import React from "react";
import {
  Navbar,
  Nav,
  NavDropdown,
  Container,
  Button,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import {
  FaEnvelope,
  FaNewspaper,
  FaSignOutAlt,
  FaStickyNote,
  FaUser,
  FaUserCircle,
  FaUsers,
} from "react-icons/fa";

import { useAuth } from "../context/AuthContext";

const scrollTop = () =>
  window.scrollTo({ top: 0, behavior: "smooth" });

function CustomNavbar() {
  const { isAuthenticated, isAdmin, user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/", { replace: true });
  };

  return (
    <>
      {/* Bootstrap's dropdown defaults to a light menu on a light caret —
          both need overriding to sit on the dark navbar. */}
      <style>{`
        .sarvavya-profile .dropdown-toggle { color: #fff; }
        .sarvavya-profile .dropdown-toggle:hover,
        .sarvavya-profile .dropdown-toggle:focus,
        .sarvavya-profile.show .dropdown-toggle { color: #ff9066; }
        .sarvavya-profile .dropdown-menu {
          background: #1e293b;
          border: 1px solid #334155;
          border-radius: 12px;
          padding: 8px;
          margin-top: 10px;
          min-width: 232px;
          box-shadow: 0 18px 40px rgba(0,0,0,0.45);
        }
        .sarvavya-profile .dropdown-item {
          color: #e2e8f0;
          border-radius: 8px;
          padding: 8px 12px;
          font-size: 0.92rem;
          display: flex;
          align-items: center;
        }
        .sarvavya-profile .dropdown-item:hover,
        .sarvavya-profile .dropdown-item:focus {
          background: #ff6b35;
          color: #0f172a;
        }
        .sarvavya-profile .dropdown-divider {
          border-color: #334155;
          margin: 6px 0;
        }
      `}</style>

      <Navbar
        expand="lg"
        sticky="top"
        className="shadow-sm"
        style={{
          background: "rgba(15,23,42,0.95)",
          backdropFilter: "blur(10px)",
        }}
      >
        <Container>

          <Navbar.Brand
            as={Link}
            to="/"
            className="fw-bold text-white"
            style={{
              fontSize: "1.5rem",
              letterSpacing: "1px",
            }}
          >
            SARVAVYA
          </Navbar.Brand>

          <Navbar.Toggle
            aria-controls="navbar-nav"
            className="bg-light"
          />

          <Navbar.Collapse id="navbar-nav">
            <Nav className="ms-auto align-items-center">

              <Nav.Link as={Link} to="/" className="text-white"
              onClick={() =>
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      })
    }>
                Home
              </Nav.Link>
  <Nav.Link
    as={Link}
    to="/about"
    className="text-white"
    onClick={() =>
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      })
    }
  >
    About
  </Nav.Link>

              <Nav.Link
    as={Link}
    to="/services"
    className="text-white"
    onClick={() =>
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      })
    }
  >
    Services
  </Nav.Link>

              <Nav.Link as={Link} to="/technology" className="text-white" onClick={() =>
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      })
    }>
                Technology
              </Nav.Link>

              <Nav.Link as={Link} to="/industries" className="text-white" onClick={() =>
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      })
    }>
                Industries
              </Nav.Link>

              <Nav.Link as={Link} to="/case-studies" className="text-white"
              onClick={() =>
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      })
    }>
                Case Studies
              </Nav.Link>

              <Nav.Link as={Link} to="/blog" className="text-white" onClick={() =>
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      })
    }>
                Blog
              </Nav.Link>

              <Nav.Link as={Link} to="/notes" className="text-white" onClick={() =>
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      })
    }>
                Notes
              </Nav.Link>

              {isAuthenticated ? (
                <NavDropdown
                  align="end"
                  id="profile-menu"
                  className="sarvavya-profile"
                  title={
                    <span className="d-inline-flex align-items-center gap-2">
                      <FaUserCircle style={{ fontSize: "1.15rem" }} />
                      {user?.name?.split(" ")[0] || "Account"}
                    </span>
                  }
                >
                  {/* Who you're signed in as — the menu is otherwise unlabelled */}
                  <div className="px-3 pt-1 pb-2">
                    <div className="fw-bold text-white text-truncate">
                      {user?.name}
                    </div>
                    <div
                      className="text-truncate"
                      style={{ fontSize: "0.75rem", color: "#94a3b8" }}
                    >
                      {user?.email}
                    </div>
                  </div>

                  <NavDropdown.Divider />

                  <NavDropdown.Item as={Link} to="/account" onClick={scrollTop}>
                    <FaUser className="me-2" />
                    My Account
                  </NavDropdown.Item>

                  <NavDropdown.Item as={Link} to="/notes" onClick={scrollTop}>
                    <FaStickyNote className="me-2" />
                    Notes
                  </NavDropdown.Item>

                  <NavDropdown.Item as={Link} to="/contact" onClick={scrollTop}>
                    <FaEnvelope className="me-2" />
                    Contact Us
                  </NavDropdown.Item>

                  {isAdmin && (
                    <>
                      <NavDropdown.Divider />
                      <NavDropdown.Item
                        as={Link}
                        to="/admin/blog"
                        onClick={scrollTop}
                      >
                        <FaNewspaper className="me-2" />
                        Manage Blog
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        as={Link}
                        to="/admin/users"
                        onClick={scrollTop}
                      >
                        <FaUsers className="me-2" />
                        Manage Users
                      </NavDropdown.Item>
                    </>
                  )}

                  <NavDropdown.Divider />

                  <NavDropdown.Item onClick={handleLogout}>
                    <FaSignOutAlt className="me-2" />
                    Logout
                  </NavDropdown.Item>
                </NavDropdown>
              ) : (
                <>
                  <Nav.Link
                    as={Link}
                    to="/login"
                    className="text-white"
                    onClick={scrollTop}
                  >
                    Login
                  </Nav.Link>

                  {/* Signed-in users reach Contact from the profile menu;
                      guests have no menu, so they keep the CTA button. */}
                  <Button
                    as={Link}
                    to="/contact"
                    variant="warning"
                    className="ms-3 fw-bold"
                    onClick={scrollTop}
                  >
                    Contact Us
                  </Button>
                </>
              )}

              </Nav>
            </Navbar.Collapse>

        </Container>
      </Navbar>
    </>
  );
}

export default CustomNavbar;